module.exports = __webpack_public_path__ + "img/file-type-media-alt.a4c70446.svg";